// light/dark theme: persisted in localStorage, applied as data-theme on <html>.
// The initial value is set by an inline script in index.html (before paint) to avoid a flash.

const BG = {light: '#f5f2ed', dark: '#191714'}

export const getTheme = () => document.documentElement.getAttribute('data-theme') || 'light'

export const setTheme = t => {
  document.documentElement.setAttribute('data-theme', t)
  try {
    localStorage.setItem('theme', t)
  } catch (e) {}
  const meta = document.querySelector('meta[name="theme-color"]')
  if (meta) meta.setAttribute('content', BG[t] || BG.light)
}

export const toggleTheme = () => {
  const next = getTheme() === 'dark' ? 'light' : 'dark'
  setTheme(next)
  return next
}
